// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"6f9d7b02","164":"a97cf6e4","254":"450d9fff","301":"1114fcae","444":"1ad284b2","453":"4bb6afec","721":"c1f8b85f"}[chunkId] + ".chunk.js";
};